import { Input } from '@/components/ui/input';
import { useSearchingStore } from '../../../store/useSearchStore';
import { useDebounce } from '@/hooks/useDebounce';
import { FilterButton } from '@/components/ui/filter-button';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

export const Filters = () => {
  const { searchPage, filters, handleToggleFilter, updateFilters, fixedTypes, clearFilters } = useSearchingStore();
  const { value: searchTerm, onChangeValue: onChangeSearchTerm } = useDebounce(
    (text) => updateFilters({ ...filters, searchTerm: text }),
    500,
    filters.searchTerm,
  );

  const hasActiveFilters = Boolean(filters.searchTerm || filters.contentTypes?.length);

  const allContentTypes = [...(fixedTypes ?? []), ...(searchPage?.knowledgeBaseTypes?.map(({ type }) => type) ?? [])];

  const searchPlaceholder = searchPage?.searchPage?.placeholder || 'Type to search';

  return (
    <div className="flex flex-col gap-4">
      <section className="mb-sh-30">
        <AnimatedFadeInComponent>
          <Input
            theme="search"
            placeholder={searchPlaceholder}
            value={searchTerm}
            onChange={(e) => onChangeSearchTerm(e.target.value)}
            className="max-w-full"
            aria-label={searchPlaceholder}
          />
        </AnimatedFadeInComponent>
      </section>
      <div>
        {allContentTypes.length > 0 && (
          <div className="flex flex-wrap items-center justify-center gap-2">
            {allContentTypes.map((type) => (
              <FilterButton
                key={type}
                isSelected={filters.contentTypes?.includes(type) || false}
                hasBorder
                showColorIndicator
                onClick={() => handleToggleFilter('contentTypes', type)}>
                {type}
              </FilterButton>
            ))}

            {hasActiveFilters && (
              <button
                type="button"
                onClick={clearFilters}
                className="font-haffer text-sh-14-20 font-bold text-black-100 hover:underline"
                aria-label="Clear all filters">
                Clear
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
